import { Button, Select } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { MONTHS, shiftMonth } from "../utils/period";

export function PeriodPicker({
  year,
  month,
  years,
  onChange,
  allowAll = true,
}: {
  year?: number;
  month?: number;
  years: number[];
  allowAll?: boolean;
  onChange: (year: number | undefined, month: number | undefined) => void;
}) {
  const options = [
    ...new Set([...years, new Date().getFullYear(), ...(year ? [year] : [])]),
  ].sort((a, b) => b - a);
  const move = (delta: number) => {
    if (year === undefined || month === undefined) return;
    const next = shiftMonth(year, month, delta);
    onChange(next.year, next.month);
  };
  return (
    <div className="period-picker">
      <label>
        <span>Rok</span>
        <Select
          aria-label="Rok"
          value={year ?? "all"}
          onChange={(value) =>
            onChange(
              value === "all" ? undefined : Number(value),
              value === "all" ? undefined : month,
            )
          }
          options={[
            ...(allowAll ? [{ value: "all", label: "Wszystkie lata" }] : []),
            ...options.map((value) => ({
              value: String(value),
              label: String(value),
            })),
          ].map((option) => ({
            ...option,
            value: option.value === "all" ? "all" : Number(option.value),
          }))}
        />
      </label>
      {year !== undefined && (
        <label>
          <span>Miesiąc</span>
          <Select
            aria-label="Miesiąc"
            value={month ?? 0}
            onChange={(value) => onChange(year, value || undefined)}
            options={[
              { value: 0, label: "Cały rok" },
              ...MONTHS.map((label, i) => ({ value: i + 1, label })),
            ]}
          />
        </label>
      )}
      {year !== undefined && month !== undefined && (
        <div className="month-navigation">
          <Button
            aria-label="Poprzedni miesiąc"
            disabled={year === 1900 && month === 1}
            icon={<LeftOutlined />}
            onClick={() => move(-1)}
          />
          <Button
            aria-label="Następny miesiąc"
            disabled={year === 2100 && month === 12}
            icon={<RightOutlined />}
            onClick={() => move(1)}
          />
        </div>
      )}
    </div>
  );
}
